module.exports = __webpack_public_path__ + "static/DSC_9343-29c934053b0c16581230a67c9366d633.jpg";